import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import adConfig from '../../lib/advertising/slots/homepage-top-banner';
import { getCurrentClubIncludesAdverts } from '../../store/clubs/selectors';
import Advert from './advert';

const HomepageTopBanner = ({ includeAdverts, style: customStyle, uid }) => {
  if (!includeAdverts) return null;

  const adProps = {};
  if (uid) {
    adProps.key = uid;
  }

  return <Advert adConfig={adConfig} style={customStyle} {...adProps} />;
};

HomepageTopBanner.propTypes = {
  includeAdverts: PropTypes.bool.isRequired,
  style: PropTypes.shape(),
  uid: PropTypes.string,
};
HomepageTopBanner.defaultProps = {
  style: {},
  uid: null,
};
const mapStateToProps = (state) => ({
  includeAdverts: getCurrentClubIncludesAdverts(state),
});
export default connect(mapStateToProps)(HomepageTopBanner);
